import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { useRecaptchaEnterpriseContext } from './RecaptchaEnterpriseProvider';

export interface GoogleRecaptchaProps {
  onVerify: (token: string) => void;
  onError?: () => void;
  action?: string;
}

export const GoogleRecaptcha: React.FC<GoogleRecaptchaProps> = ({ onVerify, onError, action = 'registration' }) => {
  const { isLoaded, executeRecaptcha, siteKey } = useRecaptchaEnterpriseContext();
  const hasExecutedRef = useRef(false);

  useEffect(() => {
    if (isLoaded && !hasExecutedRef.current) {
      hasExecutedRef.current = true;

      const handleExecute = async () => {
        try {
          const token = await executeRecaptcha(action);
          if (token) {
            onVerify(token);
          } else {
            onError?.();
          }
        } catch (error) {
          console.error('reCAPTCHA execution failed:', error);
          onError?.();
        }
      };

      handleExecute();
    }
  }, [isLoaded, executeRecaptcha, action, onVerify, onError]);

  // Don't render if no site key is configured
  if (!siteKey) {
    return (
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography variant='caption' color='warning.main'>
          reCAPTCHA Enterprise not configured for this environment
        </Typography>
      </Box>
    );
  }

  return null;
};
